import React, { useState } from "react";
import { FaWhatsapp, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import "../social/Social.css";

const Social = () => {
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [phoneOpen, setPhoneOpen] = useState(false);
  const [gmailOpen, setGmailOpen] = useState(false);
  const openWhatsapp = () => {
    setWhatsappOpen(true);
    const phoneNumber = "+919311797248";
    window.location.href = `https://wa.me/${phoneNumber}`;
  };

  const openPhone = () => {
    setPhoneOpen(true);
    const phoneNumber = "+919311797248";
    window.open(`tel:${phoneNumber}`);
  };


  const openGmail = () => {
    setGmailOpen(true);
    const emailAddress = "info@gautamsolar.com";
    window.open(`mailto:${emailAddress}`);
  };

  return (
    <div className="contact-icons">
      <div
        className={`icon ${whatsappOpen ? "open" : ""}`}
        onClick={openWhatsapp}
      >
        <FaWhatsapp size={20} />
      </div>
      <div className={`icon ${phoneOpen ? "open" : ""}`} onClick={openPhone}>
        {/* <FaPhone size={20}/> */}
        <FaPhoneAlt size={18} />
      </div>
      <div className={`icon ${gmailOpen ? "open" : ""}`} onClick={openGmail}>
        <FaEnvelope size={20} />
      </div>
    </div>
  );
};

export default Social;
